// Shared business contact for every public contact link.
const phone = '+8613434868373'
const email = 'thprefabhouse@vip.qq.com'

export const businessContact = Object.freeze({
  name: 'Daisy Yang',
  phone: '+86-13434868373',
  email,
  phoneHref: `tel:${phone}`,
  emailHref: `mailto:${email}`,
  whatsappHref: `https://api.whatsapp.com/send?phone=${phone.slice(1)}`
})
